/** Dashboard için sayı / para biçimlendirme (de-DE). */
export const eur = (n, digits = 2) =>
  `€ ${(Number(n) || 0).toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

export const eurShort = (n) => eur(n, 0);

export const num = (n) => (Number(n) || 0).toLocaleString('de-DE', { maximumFractionDigits: 1 });

/** Achsenbeschriftung: 12.400 → 12,4k */
export const axisEur = (n) => {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1000) return `${(v / 1000).toLocaleString('de-DE', { maximumFractionDigits: 1 })}k`;
  return v.toLocaleString('de-DE', { maximumFractionDigits: 0 });
};
